import React from "react";

export default function Toggle({
	id,
	name,
	selected = false,
	value,
	onChange,
	...rest
}) {
	return (
		<div className="flex items-center w-full mb-6">
			<label htmlFor={id} className="flex items-center cursor-pointer">
				<div className="relative">
					<input
						type="checkbox"
						id={id}
						name={id}
						value={id}
						onChange={(e) => {
							onChange(e.target.value);
						}}
						checked={selected}
						className="toggle-input sr-only"
					/>
					<div className="toggle-track bg-gray-500 h-6 rounded-2xl w-10"></div>
					<div className="toggle-dot absolute left-1 top-1 bg-white rounded-2xl transition h-4 w-4"></div>
				</div>
				<div className="ml-3 text-gray-700 font-medium">{name}</div>
			</label>
		</div>
	);
}
